import { useEffect, useState, Fragment } from 'react';
import { Image } from 'react-bootstrap';
import _get from 'lodash/get';
import { useStore } from 'store';
import { fetchPlans } from 'store/actions/catalogs';
import iconRegalo from 'assets/img/quiero.png';
import iconDinero from 'assets/img/virtual.png';
import './index.scss';
import { useWindowSize } from 'hooks';

const MY_DAY_CATEGORY = 'Mi día';
const I_WANT_PLAN = 'LO QUIERO';

const Plan = ({ values, onSaveData, handleNext, valueComplete ,handlerPlan}) => {
  const [activeOption, setActiveOption] = useState(values ? values.plan : '');

  const [catalogs, dispatch] = useStore((state) => state.catalogs);
  const { plans = [] } = catalogs;

  const isMyDay =
    _get(valueComplete, 'select_event.celebration', '') === MY_DAY_CATEGORY;
  
  const [, { isMobile }] = useWindowSize();

  const saveOption = async(plan) => {
    
    onSaveData({
      plan,
      valid: true
    });
    
    setActiveOption(plan);
  };
  useEffect(() => {
    dispatch(fetchPlans());
  }, []);

  const renderPlanItem = (item, isLast= false) => {
    const handleClick = () => {
      saveOption(item.id);
      
 
        handlerPlan(item.id);
    
        handleNext();

      
    };
    return (
        <div
          onClick={handleClick}
          onKeyPress={handleClick}
          tabIndex={0}
          role="button"
          className={`PlanItem ${activeOption === item.id ? 'active' : ''}`}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            maxWidth: '300px', // Ajusta el ancho máximo según tus necesidades
            margin: '0 auto', // Centra horizontalmente el elemento
            padding: isMobile?'10px':'20px',
            border: isMobile?'1px solid #E6E6E6':'1px solid #ccc',
            borderRadius: '8px',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
            marginBottom: isLast?'0px':'25px',
          }}
        >
          <div className="PlanItem__img">
            <Image
              src={item.id === 1 ? iconRegalo : iconDinero}
              alt="Plan image"
              style={{
                maxWidth: isMobile?'75%':'85%', // Ajusta el tamaño máximo de la imagen según tus necesidades
                height: 'auto', // Ajusta la altura automáticamente
            }}
            />
          </div>

          <p className="PlanItem__text">{item.name}</p>

          <p className="PlanDescription__text">{item.text}</p>
        </div>

  );
  };
  const plansFull = [
    {
      ...plans[0],
      text: 'Los regalos convertidos en efectivo directo a tu monedero electronico'
    },
    {
      ...plans[1],
      text: 'Recibe todos tus regalos, en un plan tradicional de Mesa de Regalos'
    }
  ].filter((plan) => (isMyDay ? plan?.name === I_WANT_PLAN : true));

  return (
    <div className="Plan">
      {plansFull.map((item, i = 1) => (
        <Fragment key={i}>
          {renderPlanItem(item, ((plansFull.length - 1) === i))}
        </Fragment>
      ))}
    </div>
  );
};

export default Plan;
